import AnalyticsContext from '../context/analytics-context.js';
import useInit from '@@app/providers/analytics/useInit.js';
import useData from '@@app/providers/analytics/useData.js';
import useEvents from '@@app/providers/analytics/useEvents.js';

const AnalyticsProvider = ({ middleFeatures, children }) => {

  const {
    getEvent,
    getCommonData,
    loading,
    getAnalyticsInformation,
    analyticsEvents,
    dataInit
  } = useData(middleFeatures);
  const { provider, loaded } = useInit(dataInit);

  const {
    trackEvent,
    trackButtonClick
  } = useEvents({
    loaded,
    provider,
    getEvent,
    loading,
    getCommonData,
    analyticsEvents,
    getAnalyticsInformation
  });

  return <AnalyticsContext.Provider
    value={{
      trackEvent,
      trackButtonClick,
      middleFeatures
    }}
  >
    {children}
  </AnalyticsContext.Provider>;
};

export default AnalyticsProvider;
